'use client'

import { type Spacing, getOuterSpacingClassNames } from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

import { type HeroBannerInputProps } from './HeroBanner.builder'
import { HeroMedia } from './HeroMedia'

export const HeroBanner = ({
  backgroundColor,
  mediaLandscape,
  mediaLandscapeBlur,
  mediaPortrait,
  mediaPortraitBlur,
  children,
  outerSpacing,
}: HeroBannerInputProps & { outerSpacing?: Spacing }) => {
  return (
    <div
      className={cn(
        'relative flex h-screen items-end overflow-hidden md:h-[630px] md:w-full md:items-center',
        getOuterSpacingClassNames(outerSpacing)
      )}
    >
      <div className=" absolute inset-0 bg-bodi-black" style={{ backgroundColor }}>
        {/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */}
        {(mediaPortrait || mediaLandscape) && (
          <>
            <HeroMedia
              className="block object-cover lg:hidden"
              src={mediaPortrait || mediaLandscape}
              blurDataURL={mediaPortraitBlur || mediaLandscapeBlur}
            />
            <HeroMedia
              className="hidden object-cover lg:block"
              src={mediaLandscape || mediaPortrait}
              blurDataURL={mediaLandscapeBlur || mediaPortraitBlur}
            />
          </>
        )}
        {/* eslint-enable @typescript-eslint/prefer-nullish-coalescing */}
      </div>
      {children}
    </div>
  )
}
